import React from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import { Form, Row, Col, Button, Card } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCancel, faCircleUser } from "@fortawesome/free-solid-svg-icons";
// import RenukaImage from "@/assets/images/Renuka_Icon.jpg";

// import { authenticationService } from "@/services/api_functions";
import {
  authenticationService,
  MobileExistCheck,
} from "@/services/api_functions";
import { withRouter } from "../routes";

function Login(props) {
  console.log("props", props);
  return (
    <>
      <Formik
        validateOnChange={false}
        validateOnBlur={false}
        initialValues={{
          mobile_number: "",
        }}
        validationSchema={Yup.object().shape({
          mobile_number: Yup.string()
            .trim()
            .max(25)
            .min(2)
            .required("mobile_number is required"),
        })}
        onSubmit={(value, action) => {
          // authenticationService;
          console.log("Values", value);
          // action.resetForm();
          let formData = { mobile_number: value.mobile_number };

          // formData.append("mobile_number", value.mobile_number);
          MobileExistCheck(formData)
            .then((response) => {
              if (response.status == 200) {
                console.log("response", response);
                alert("Your Mobile number is exist");
                // resetForm();
                action.resetForm();
              } else if (response.responseStatus == 401) {
                alert("Error in Fetching data");
              }
            })
            .catch((error) => {
              console.log("Server Problem");
            });
        }}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleSubmit,
          isSubmitting,
          resetForm,
        }) => (
          <Form
            onSubmit={handleSubmit}
            noValidation
            className="login-form-style mt-3"
          >
            <div className="mainDiv">
              <Row className="justify-content-center">
                <Col lg={6}>
                  {/* <Row className="text-center">
                    <Col lg={12}>
                      <img src={RenukaImage} alt="" className="renuka_icon" />
                    </Col>
                  </Row> */}
                  <Card>
                    <Card.Header style={{ fontWeight: "600" }}>
                      User Deletion Form
                    </Card.Header>
                    <Card.Body>
                      <Row className="justify-content-center">
                        <Col
                          md={12}
                          xs={12}
                          className="form-control-width mb-2"
                        >
                          <Form.Group>
                            <Form.Label>Enter Mobile Number</Form.Label>
                            <Form.Control
                              placeholder="Enter Mobile Number"
                              aria-label="mobile_number"
                              autoComplete="true"
                              aria-describedby="basic-addon1"
                              name="mobile_number"
                              maxLength={10}
                              id="mobile_number"
                              type="text"
                              onChange={handleChange}
                              value={values.mobile_number}
                            />
                            <span className="text-danger">
                              {errors.mobile_number}
                            </span>
                          </Form.Group>
                        </Col>
                      </Row>
                      <Row className="text-center justify-content-center">
                        <Col md={12} xs={12}>
                          <Row>
                            <Col lg={6}>
                              <Button type="submit" className="button-style">
                                <FontAwesomeIcon icon={faCircleUser} />
                                Submit
                              </Button>
                            </Col>
                            <Col lg={6}>
                              <Button variant="secondary">
                                <FontAwesomeIcon icon={faCancel} />
                                Cancel
                              </Button>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            </div>
          </Form>
        )}
      </Formik>
    </>
  );
}

export default withRouter(Login);
